export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: '/dashboard/analytics',
    name: "Analytics",
    slug: "dashboard-analytics",
    icon: 'ActivityIcon',
    i18n: "Dashboard"
  },
  {
    header: "BackOffice",
    icon: "CodeIcon",
    i18n: "BackOffice",
    items: [
      {
        url: '/users/list',
        name: 'Users',
        slug: "pharmacies-list",
        icon: 'UserIcon',
        i18n: "Users"
      },
      {
        url: '/categories/list',
        name: 'Categories',
        slug: "categories-list",
        icon: 'ListIcon',
        i18n: "Categories"
      },
      {
        url: '/news/list',
        name: 'News',
        slug: "news-list",
        icon: 'FileTextIcon',
        i18n: "News"
      },
      {
        url: '/campaigns/list',
        name: 'Campaigns',
        slug: "campaigns-list",
        icon: 'FlagIcon',
        i18n: "Campaigns"
      },
      {
        url: '/newspaper-pdfs/list',
        name: 'NewspaperPdfs',
        slug: "newspaper-pdfs-list",
        icon: 'BookOpenIcon',
        i18n: "NewspaperPdfs"
      },
      {
        url: '/classifieds/list',
        name: 'Classifieds',
        slug: "classifieds-list",
        icon: 'BriefcaseIcon',
        i18n: "Classifieds"
      },
      {
        url: '/daily-covers/list',
        name: 'DailyCovers',
        slug: "daily-covers-list",
        icon: 'CalendarIcon',
        i18n: "DailyCovers"
      },
      {
        url: null,
        name: 'Newsletter',
        slug: "newsletter",
        icon: 'MailIcon',
        i18n: "Newsletter",
        submenu: [
          {
            url: '/newsletter/subscribers/list',
            name: "NewsletterSubscribers",
            slug: "newsletter-subscribers-list",
            i18n: "NewsletterSubscribers",
          },
          {
            url: '/newsletter/templates/list',
            name: "NewsletterTemplates",
            slug: "newsletter-templates-list",
            i18n: "NewsletterTemplates",
          },
          {
            url: '/newsletter/campaigns/list',
            name: "NewsletterCampaigns",
            slug: "newsletter-campaigns-list",
            i18n: "NewsletterCampaigns",
          },
        ]
      },
    ]
  },
  {
    header: "Others",
    icon: "MoreHorizontalIcon",
    i18n: "Others",
    items: [
      {
        url: null,
        name: "Support",
        icon: "SmileIcon",
        i18n: "Support",
        submenu: [
          {
            url: 'https://clean-code.tech/',
            name: "Raise Support",
            icon: "LifeBuoyIcon",
            slug: "external",
            i18n: "RaiseSupport",
            target: "_blank"
          }
        ]
      }
    ]
  }
]
